import { useProgress } from '@react-three/drei'
import './loading.css'


const Loading = () => {
  const { active, progress } = useProgress()
 
  return active ? (
    <div className="loading">
      <p>Hold tight for a few seconds</p>
      <h1>Antino Kila</h1>
      <span className="loading-span">
        {Math.floor(progress)}%
      </span>
      <div className="fly-by"></div>
    </div>
  ) : null
}

export default Loading